import { Navigate, useLocation } from "react-router-dom";

/** Salary structures live on /salary-v2/structures. This route only forwards old links. */
export default function SalaryTemplates() {
  const location = useLocation();
  const search = location.search || "";
  return <Navigate to={`/salary-v2/structures${search}`} replace />;
}
